/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how cell selection is animated.
 */
export var CellSelectionAnimationMode = /*@__PURE__*/ (function (CellSelectionAnimationMode) {
    /**
     * The correct animation mode is automatically selected.
     */
    CellSelectionAnimationMode[CellSelectionAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    CellSelectionAnimationMode[CellSelectionAnimationMode["None"] = 1] = "None";
    /**
     * The selection color and the normal background color are blended between.
     */
    CellSelectionAnimationMode[CellSelectionAnimationMode["ColorBlend"] = 2] = "ColorBlend";
    return CellSelectionAnimationMode;
})({});
/**
 * @hidden
 */
export var CellSelectionAnimationMode_$type = /*@__PURE__*/ markEnum('CellSelectionAnimationMode', 'Auto,0|None,1|ColorBlend,2');
//# sourceMappingURL=CellSelectionAnimationMode.js.map
